import * as React from 'react';
import { FormattedDate, InjectedIntlProps, injectIntl } from 'react-intl';
import BooksCheckInput, {
  InputType,
} from '../../../../components/books/model1/forms/BooksCheckInput';
import { PaymentMethodTicket } from '../../../../interfaces/merchants/resources/books';
import BookingPurchaseProduct from './common/BookingPurchaseProduct';

import css from './InputPaymentMyTicket.module.scss';

interface Props {
  merchantId: string;
  paymentMethod: PaymentMethodTicket;
  onSelect: (purchasedSelection: string) => void;
  onClose: () => void;
  mySelection?: string;
}

class InputPaymentMyTicket extends React.Component<Props & InjectedIntlProps> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  public componentDidMount() {
    const {
      onSelect,
      paymentMethod: { purchased_products },
    } = this.props;
    if (purchased_products.length !== 0) {
      onSelect(purchased_products[0].public_id.toString());
    }
  }

  public componentDidUpdate(prevProps: Props) {
    const {
      onSelect,
      paymentMethod: { purchased_products },
    } = this.props;
    if (
      purchased_products !== prevProps.paymentMethod.purchased_products &&
      purchased_products.length !== 0
    ) {
      onSelect(purchased_products[0].public_id.toString());
    }
  }

  private handleSelect(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { value },
    } = e;
    this.props.onSelect(value);
  }

  public render() {
    const {
      intl,
      merchantId,
      paymentMethod: { purchased_products, products },
      mySelection,
      onClose,
    } = this.props;
    const isDisplayRetailer = purchased_products.length === 0;
    return (
      <li className={css.InputPaymentMyTicket}>
        {purchased_products.map(p => (
          <BooksCheckInput
            key={p.public_id}
            className={css.InputPaymentMyTicket__Item}
            labelClassName={css.InputPaymentMyTicket__Label}
            type={InputType.Radio}
            value={p.public_id}
            checked={mySelection === p.public_id.toString()}
            onChange={this.handleSelect}
            name="payment-ticket"
          >
            <>
              <span>
                {p.name}
                &nbsp;&nbsp;&nbsp;
                {p.consumption}
                {intl.formatMessage({ id: 'books.paymentMethod.consumption' })}
                {p.ticket_books.map(t => (
                  <React.Fragment key={t.public_id}>
                    <span className={css.InputPaymentMyTicket__Description}>
                      {intl.formatMessage({
                        id: 'books.paymentMethod.expirationDate',
                      })}
                      〜
                      <FormattedDate
                        value={new Date(t.expires_at * 1000)}
                        year="numeric"
                        month="short"
                        day="numeric"
                      />
                      &nbsp;&nbsp;&nbsp;
                      {intl.formatMessage({ id: 'books.paymentMethod.rest' })}
                      {t.remain_count}
                    </span>
                  </React.Fragment>
                ))}
              </span>
            </>
          </BooksCheckInput>
        ))}
        {isDisplayRetailer && (
          <div className={css.InputPaymentMyTicket__Available}>
            {intl.formatMessage({
              id: 'books.forms.youGetSubscriptionAndTicket',
            })}
            {products.map(product => (
              <BookingPurchaseProduct
                key={product.public_id}
                merchantId={merchantId}
                product={product}
                onClose={onClose}
              />
            ))}
          </div>
        )}
      </li>
    );
  }
}

export default injectIntl(InputPaymentMyTicket);
